import { render, staticRenderFns } from "./popup-create-task.vue?vue&type=template&id=e6524974&scoped=true"
import script from "./popup-create-task.vue?vue&type=script&lang=js"
export * from "./popup-create-task.vue?vue&type=script&lang=js"
import style0 from "./popup-create-task.vue?vue&type=style&index=0&id=e6524974&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6524974",
  null
  
)

export default component.exports